export default "__VITE_ASSET__nOIwVMLp__"